import { render, staticRenderFns } from "./Game5-14.vue?vue&type=template&id=d270c2be&scoped=true&"
import script from "./Game5-14.vue?vue&type=script&lang=js&"
export * from "./Game5-14.vue?vue&type=script&lang=js&"
import style0 from "./Game5-14.vue?vue&type=style&index=0&id=d270c2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d270c2be",
  null
  
)

export default component.exports